type AnyFn = (...args: unknown[]) => unknown;

export function initCypressStripeLoader() {
  if (!window.Cypress) {
    return;
  }

  const script = document.createElement('script');
  script.src = 'https://js.stripe.com/v3/';
  script.onload = () => {
    const win = window as unknown as Record<string, unknown>;
    const origStripe = win['Stripe'] as AnyFn | undefined;

    if (origStripe && window.mockStripeMethods) {
      win['Stripe'] = (...args: unknown[]) => {
        return {
          ...(origStripe(...args) as object),
          ...window.mockStripeMethods,
        };
      };
    }
  };
  document.head.appendChild(script);
}
